// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"af3a5697","200":"1fd9f304","548":"70e67bf3","710":"b7616821","845":"92549cb5","917":"d8f9c5f1"}[chunkId] + ".chunk.js";
};